import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { IProduct, IProductEdp } from './IProduct';

export interface PdpAdvanceOrderProps {
    SelectedEdpItem: IProductEdp;
}
// Easiest way to declare a Function Component; return type is inferred.
const PdpAdvanceOrder = ({ SelectedEdpItem }: PdpAdvanceOrderProps) => {
    const isAdvanceOrder = useMemo(() => {
        if (!SelectedEdpItem || !SelectedEdpItem?.IsAdvanceOrBackOrder) {
            return false;
        }
        return true;
    }, [SelectedEdpItem]);

    const [isStyledMessage, setIsStyledMessage] = useState(false);
    const [advanceOrderMessage, setAdvanceOrderMessage] = useState(null);

    useEffect(() => {
        if (!SelectedEdpItem || !SelectedEdpItem?.SkuAvailabilityMessage) {
            setAdvanceOrderMessage('');
        } else {
            const message = SelectedEdpItem?.SkuAvailabilityMessage;
            if (message && message.includes(':')) {
                setIsStyledMessage(true);
            } else {
                setIsStyledMessage(false);
            }
            setAdvanceOrderMessage(message);
        }
    }, [SelectedEdpItem]);

    return (
        <>
            {isAdvanceOrder && (
                <>
                    <div className="pdp-description__advance-order">
                        {isStyledMessage && (
                            <>
                                <span>{advanceOrderMessage.split(':')[0]}:</span>
                                <b>{advanceOrderMessage.split(':')[1]}</b>
                            </>
                        )}
                        {!isStyledMessage && <div>{advanceOrderMessage}</div>}
                    </div>
                </>
            )}
        </>
    );
};

export default PdpAdvanceOrder;
